import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
})
export class ButtonComponent {
  /**
   * * Inputs
   */
  @Output() handleClick: EventEmitter<any> = new EventEmitter<any>();
  /**
   * * Outputs
   */
  @Input() icon: string;
  @Input() type: 'button' | 'submit';
  @Input() btnStyle: 'main' | 'second';
  @Input() disabled = false;
  @Input() text: string;
  @Input() tooltipTitle: string;
  @Input() tooltipPosition: 'top' | 'left' | 'right' | 'bottom' = 'top';
  @Input() routerLink: any[] | null = null;
  @Input() styleClass: string;

  /* ====================================
  *             MAIN FEATURES
  ======================================= */

  onClickEvent() {
    this.handleClick.emit(true);
  }
}
